import { takeLatest, put } from 'redux-saga/effects';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { SET_USER_FETCH_STATUS, SET_CONNECTION } from '../../types';
import { SUCCESS } from '@modules/raccoon/src/api/constants';

function* createConnection({ payload }) {
  if (payload === SUCCESS) {
    // const newConnection = yield new HubConnectionBuilder()
    // .withUrl(`${globalThis.config.raccoon.apiUrl}/hubs/chat`)
    // .withAutomaticReconnect()
    // .build();
    // yield put({ type: SET_CONNECTION, payload: newConnection });
  }
}

export default function* watchSignalRSaga() {
  yield takeLatest(SET_USER_FETCH_STATUS, createConnection);
}
